import { useEffect, useState } from 'react'
import { ScrollableListData } from 'modules/ui/molecules/ScrollableList'

type doubleTheDonationData = {
  id: number
  company_name: string
  subsidiaries: string[]
  highlight: {
    subsidiaries: string[]
  }
}

const useDoubleTheDonationCompaniesSearch = (query: string, pageNumber: number) => {
  const [data, setData] = useState<ScrollableListData[]>([])
  const [companies, setCompanies] = useState<doubleTheDonationData[]>([])
  const [error] = useState(false)
  const [loading, setLoading] = useState(true)

  const getDoubleTheDonationMappedData = (doubleTheDonationData: any) => {
    const highLightedCompanyName = doubleTheDonationData.highlight.company_name

    const toAppendCompanyName = ` (${doubleTheDonationData.company_name})`

    const highlightName = highLightedCompanyName
      ? doubleTheDonationData.highlight.company_name[0]
      : doubleTheDonationData.highlight.linkedin_names
      ? doubleTheDonationData.highlight.linkedin_names[0] + toAppendCompanyName
      : doubleTheDonationData.highlight.subsidiaries
      ? doubleTheDonationData.highlight.subsidiaries[0] + toAppendCompanyName
      : doubleTheDonationData.company_name

    const span = document.createElement('span')
    span.innerHTML = highlightName

    return {
      label: span.textContent || span.innerText,
      value: doubleTheDonationData.id,
    }
  }

  useEffect(() => {
    setData([])
  }, [query])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)

      const doubleTheDonationData: doubleTheDonationData[] = await fetch(
        `https://doublethedonation.com/api/v1/prefix?query=${query}`,
      ).then((res) => res.json())

      setCompanies(doubleTheDonationData)

      const data = doubleTheDonationData.map((c: doubleTheDonationData) =>
        getDoubleTheDonationMappedData(c),
      )

      setData(data)
      setLoading(false)
    }

    if (query) {
      fetchData()
    }
  }, [query, pageNumber])

  return { data, companies, error, loading, hasMore: false }
}

export default useDoubleTheDonationCompaniesSearch
